import { Equipe } from './equipe.model';

export class ComposicaoEquipe {
    id: number;
    estimativaId: number;
    equipeId: number;
    horaAlocacao: number;
    alocacao: number;
    qtdProfissional: number;
    equipe: Equipe;
    profCompartilhado: boolean;
    design: boolean;
    aContratar: boolean;
}
